import { useMutation } from '@tanstack/react-query';
import { personsService } from 'services';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { personAdacter } from 'adapters';
import useErrors from 'hooks/useErrors';
import { toast } from 'react-toastify';

const usePerson = (fixedEntity, type, Entities, limit, business) => {
 const { setError } = useErrors();
 const [open, setOpen] = useState(false);
 const [show, setShow] = useState(!fixedEntity?._id);
 const [bloq, setBloq] = useState(false);
 const [entities, setEntities] = useState(fixedEntity?._id ? [{ ...fixedEntity, fixed: true }] : []);
 const [isLoading, setIsLoading] = useState(false);
 const [typeEntity] = useState(
  type === 'entity' ? { new: 'createEntity', edit: 'updateEntity' } : { new: 'createCustomer', edit: 'updateCustomer' }
 );

 const {
  reset,
  watch,
  register,
  setValue,
  clearErrors,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues: {} });

 const { getPersonByDoc, ...setEntity } = personsService.useApiPersons();

 const { mutate: getEntity } = useMutation(getPersonByDoc);

 const { mutate: newEntity } = useMutation(setEntity[typeEntity.new]);

 const { mutate: updateEntity } = useMutation(setEntity[typeEntity.edit]);

 const editEntity = data => {
  setOpen(true);
  return reset(data, { keepErrors: false, keepDirty: false });
 };

 const deleteEntity = id => {
  const data = entities.filter(e => e?._id !== id);
  setEntities(data);
 };

 const onClose = () => {
  setOpen(false);
  reset({}, { keepDefaultValues: true });
 };

 const onError = e => {
  console.log(e, 'este es el error que surje');
  //if (!validation) clearErrors();
 };

 const getPerson = async data => {
  if (limit && entities.length + 1 > limit) return;
  setIsLoading(true);
  getEntity(data, {
   onSuccess: entity => {
    const { /* updatedAt, */ customer, ...newData } = entity;

    if (newData?.lastName) setBloq(true);
    else setBloq(false);

    if (newData?._id && type === 'entity') setEntities([...entities, newData]);
    else if (type === 'entity') setOpen(Object.values(newData).some(e => e === undefined) || !newData._id);

    if (customer?._id && type === 'customer') {
     const { _id, phone, email, address } = customer;
     setEntities([...entities, { ...newData, _id, phone, email, address }]);
     return reset({ ...newData, _id, phone, email, address }, { keepErrors: false, keepDirty: false });
    } else if (type === 'customer') {
     const { /* _id, */ ...newCustomer } = newData;
     reset(newCustomer, { keepErrors: false, keepDirty: false });
     return setOpen(true);
    }

    return reset(newData, { keepErrors: false, keepDirty: false });
   },
   onSettled: () => setIsLoading(false),
   onError: err => setError(err)
  });
 };

 const onSubmitData = async data => {
  setIsLoading(true);
  const newE = await personAdacter.create({ ...data, business });
  console.log(newE);
  if (watch('_id'))
   updateEntity(newE, {
    onSuccess: entity => {
     //console.log({ entity });
     setEntities(entities => entities.map(e => (e?._id === entity?._id ? { ...e, ...entity } : e))); //[...entities.filter(e => e?._id !== entity?._id), entity]);
     setOpen(false);
    },
    onError: err => setError(err),
    // eslint-disable-next-line
    onSettled: (data, error) => {
     setIsLoading(false);
     if (error) toast.error('Error al procesar la solicitud');
     toast.success(type + ' se actualizo de forma exitosa');
    }
   });
  else
   newEntity(newE, {
    onSuccess: entity => {
     const { /* updatedAt, */ customer, ...newData } = entity;
     //console.log(customer?._id ? { ...newData, _id: customer?._id } : newData);
     setEntities([...entities, customer?._id ? { ...newData, _id: customer?._id } : newData]);
     setOpen(false);
    },
    onError: err => setError(err),
    // eslint-disable-next-line
    onSettled: (data, error) => {
     setIsLoading(false);
     if (error) toast.error('Error al procesar la solicitud');
     toast.success(type + ' se creo de forma exitosa');
    }
   });
 };

 useEffect(() => {
  if ((limit && entities.length + 1 > limit) || entities.length) setShow(false);
  else if (!entities.length) setShow(true);
  Entities(entities);
 }, [entities]);

 return {
  getPerson,
  newEntity,
  watch,
  register,
  setValue,
  clearErrors,
  handleSubmit,
  errors,
  show,
  setShow,
  open,
  bloq,
  entities,
  editEntity,
  deleteEntity,
  onClose,
  onError,
  onSubmitData,
  isLoading
 };
};

usePerson.propTypes = { type: PropTypes.string };

usePerson.defaultProps = { type: 'entity' };

export default usePerson;
